module.exports = __webpack_public_path__ + "img/161.198b3fd9.jpg";